<template>
  <div id="app">
    <!-- 直接显示主要内容，无需卡密验证 -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'DeltaGrabTool'
}
</script>

<style>
body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background-color: #1e1e1e;
  color: #d4d4d4;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  justify-content: center;
  height: 100vh;
  box-sizing: border-box;
  overflow: hidden;
  padding: 10px;
}



.current-ip {
  color: #888 !important;
  font-size: 14px !important;
  margin-top: 20px !important;
}

/* 全局滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #1e1e1e;
}

::-webkit-scrollbar-thumb {
  background: #3c3c3c;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #4c4c4c;
}

/* 全局输入框样式 */
input[type="text"],
input[type="password"],
input[type="number"],
select {
  background-color: #3c3c3c;
  border: 1px solid #555;
  color: #d4d4d4;
  padding: 8px;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
  font-size: 14px;
}

input[type="text"]:focus,
input[type="password"]:focus,
input[type="number"]:focus,
select:focus {
  outline: none;
  border-color: #007acc;
}

/* 全局按钮样式 */
button {
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.2s;
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

/* 全局表格样式 */
table {
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;
}

th, td {
  border: 1px solid #3c3c3c;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #333;
  color: #dcdcaa;
}

tr:nth-child(even) {
  background-color: #2a2a2a;
}

tr:hover {
  background-color: #323232;
}


</style>



// WEBPACK FOOTER //
// src/App.vue